// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ExpandLink__Wrapper_2y1LU","Description":"ExpandLink__Description_2S_iX","Link":"ExpandLink__Link_l6C3-"};